// extracted by mini-css-extract-plugin
export default {"labtablebg":"Lab_labtablebg__6-t64","laberrortext":"Lab_laberrortext__49Jy5","lineallignment":"Lab_lineallignment__oOdj5"};